import {
    ElectionDefinition,
    GetRouteAdTargeting,
    isElectionFeatureEnabled,
    TogglesReduxState,
} from '@news-mono/web-common'
import { layout } from '../../App.routing'
import { calcRem, metrics } from '@news-mono/component-library'
import { wrapWithElectionContextNested } from '../elections/routes'

export const electionSegment = (
    electionDefinition: ElectionDefinition,
    getAdTargeting: GetRouteAdTargeting,
    toggles: TogglesReduxState,
) => {
    const { logo, electionId } = electionDefinition

    const isNavigationEnabled = isElectionFeatureEnabled(
        toggles,
        electionId,
        'election-navigation',
    )
    const isHeadToHeadEnabled = isElectionFeatureEnabled(
        toggles,
        electionDefinition.electionId,
        'election-homepage-head-to-head',
    )
    const isHeadToHeadCountdownEnabled = isElectionFeatureEnabled(
        toggles,
        electionDefinition.electionId,
        'election-head-to-head-countdown',
    )
    const isTheSwingEnabled = isElectionFeatureEnabled(
        toggles,
        electionDefinition.electionId,
        'election-homepage-the-swing',
    )
    const isTheRaceEnabled = isElectionFeatureEnabled(
        toggles,
        electionDefinition.electionId,
        'election-homepage-the-race',
    )
    const isTheSeatsEnabled = isElectionFeatureEnabled(
        toggles,
        electionDefinition.electionId,
        'election-homepage-the-seats',
    )
    const isMapEnabled = isElectionFeatureEnabled(
        toggles,
        electionDefinition.electionId,
        'election-homepage-map',
    )

    return wrapWithElectionContextNested([
        layout.nestedComposition({
            type: 'box',
            props: {
                containerWidth: metrics.thenightly.siteMetrics.mainContentWidth,
                fullWidth: true,
                flex: {
                    default: {
                        flexDirection: 'column',
                    },
                    sm: {},
                },
            },
            contentAreas: {
                main: [
                    // Head to Head component
                    ...(isHeadToHeadEnabled
                        ? [
                              layout.component({
                                  type: 'election-head-to-head-seat-count-widget',
                                  props: {
                                      electionDefinition,
                                      countdownEnabled:
                                          isHeadToHeadCountdownEnabled,
                                  },
                              }),
                          ]
                        : []),
                    // Navigation component
                    ...(isNavigationEnabled
                        ? [
                              layout.nestedComposition({
                                  type: 'box',
                                  props: {
                                      flex: {
                                          default: {
                                              flexDirection: 'column',
                                              paddingBottom: 0,
                                          },
                                          lg: {
                                              paddingBottom: calcRem(16),
                                          },
                                      },
                                  },
                                  contentAreas: {
                                      main: [
                                          layout.component({
                                              type: 'election-navigation',
                                              props: {
                                                  electionDefinition,
                                                  electionLogo: logo,
                                              },
                                          }),
                                      ],
                                  },
                              }),
                          ]
                        : [
                              layout.component({
                                  type: 'election-homepage-logo',
                                  props: { electionDefinition },
                              }),
                          ]),
                    layout.nestedComposition({
                        type: 'box',
                        props: {
                            containerWidth:
                                metrics.thenightly.siteMetrics.mainContentWidth,
                            fullWidth: true,
                            flex: {
                                default: {
                                    flexDirection: 'column',
                                    gap: calcRem(48),
                                },
                                sm: {
                                    gap: calcRem(32),
                                },
                            },
                        },
                        contentAreas: {
                            main: [
                                ...(isTheRaceEnabled
                                    ? [
                                          layout.nestedComposition({
                                              type: 'box',
                                              props: {
                                                  horizontalSpacing:
                                                      'outerMargin',
                                                  horizontalSpacingBreakpoint:
                                                      'lg',
                                              },
                                              contentAreas: {
                                                  main: [
                                                      layout.component({
                                                          type: 'election-the-race-widget',
                                                          props: {
                                                              redirectTo: `/politics/${electionDefinition.electionId}/party-totals`,
                                                              electionDefinition,
                                                              headingLevel:
                                                                  'h3',
                                                          },
                                                      }),
                                                  ],
                                              },
                                          }),
                                      ]
                                    : []),
                                layout.nestedComposition({
                                    type: 'luna',
                                    props: {
                                        asideSide: 'right',
                                        hasAfterAside: false,
                                        hasBeforeAside: true,
                                        dividerConfig: {
                                            column: {
                                                hasBeforeAsideAndAsideDivider:
                                                    false,
                                            },
                                        },
                                    },
                                    contentAreas: {
                                        beforeAside: [
                                            layout.component({
                                                type: 'card',
                                                props: {
                                                    kind: 'article-card',
                                                    dataDefinitionArgs: {
                                                        type: 'curation',
                                                        name: electionId,
                                                        offset: 0,
                                                        pageSize: 1,
                                                    },
                                                    adTargeting: getAdTargeting(
                                                        'home',
                                                        'default',
                                                        'home',
                                                    ),
                                                    imageFetchPriority: 'high',
                                                    disableImageLazyLoad: true,
                                                },
                                            }),
                                        ],
                                        afterAside: [],
                                        aside: [
                                            layout.nestedComposition({
                                                type: 'box',
                                                props: {
                                                    horizontalSpacing:
                                                        'outerMargin',
                                                    horizontalSpacingBreakpoint:
                                                        'sm',
                                                },
                                                contentAreas: {
                                                    main: [
                                                        layout.component({
                                                            type: 'juliet',
                                                            props: {
                                                                cardType: {
                                                                    type: 'landscape',
                                                                    format: 'landscape-common',
                                                                },
                                                                imageWidths: {
                                                                    mobile: '80px',
                                                                    tablet: '80px',
                                                                    desktop:
                                                                        '96px',
                                                                    fallbackWidth: 96,
                                                                    mode: 'fixed',
                                                                },
                                                                verticalSpacing:
                                                                    'md',
                                                                removeHorizontalGutters:
                                                                    true,
                                                                removeTopListPadding:
                                                                    true,
                                                                hideByline:
                                                                    false,
                                                                topicLevel:
                                                                    'parent',
                                                                hideLastDivider:
                                                                    true,
                                                                condensedInfo:
                                                                    true,
                                                                dataDefinitionArgs:
                                                                    {
                                                                        type: 'curation',
                                                                        name: electionId,
                                                                        offset: 1,
                                                                        pageSize: 6,
                                                                    },
                                                            },
                                                        }),
                                                    ],
                                                },
                                            }),
                                        ],
                                    },
                                }),
                                layout.component({
                                    type: 'ad-unit',
                                    props: {
                                        adType: 'inline',
                                        noticePosition: 'above-center',
                                        slot: {
                                            id: '0-election-1',
                                            size: 'leaderboardAbove768MrecBelow',
                                        },
                                        padding: [0, 0, 0, 0],
                                        lazyLoadingDistance: 0,
                                    },
                                }),
                                ...(isTheSwingEnabled
                                    ? [
                                          layout.nestedComposition({
                                              type: 'box',
                                              props: {
                                                  horizontalSpacing:
                                                      'outerMargin',
                                                  horizontalSpacingBreakpoint:
                                                      'lg',
                                              },
                                              contentAreas: {
                                                  main: [
                                                      layout.component({
                                                          type: 'election-swing-widget',
                                                          props: {
                                                              electionDefinition,
                                                              prevElectionYear: 2022,
                                                          },
                                                      }),
                                                  ],
                                              },
                                          }),
                                      ]
                                    : []),
                                ...(isTheSeatsEnabled
                                    ? [
                                          layout.nestedComposition({
                                              type: 'box',
                                              props: {
                                                  horizontalSpacing:
                                                      'outerMargin',
                                                  horizontalSpacingBreakpoint:
                                                      'lg',
                                              },
                                              contentAreas: {
                                                  main: [
                                                      layout.component({
                                                          type: 'election-seat-widget',
                                                          props: {
                                                              electoratePageUrl: `/politics/${electionDefinition.electionId}/electorates`,
                                                              electionDefinition,
                                                              headingLevel:
                                                                  'h3',
                                                          },
                                                      }),
                                                  ],
                                              },
                                          }),
                                          layout.component({
                                              type: 'ad-unit',
                                              props: {
                                                  adType: 'inline',
                                                  noticePosition:
                                                      'above-center',
                                                  slot: {
                                                      id: '0-election-2',
                                                      size: 'leaderboardAbove768MrecBelow',
                                                  },
                                                  padding: [0, 0, 0, 0],
                                                  lazyLoadingDistance: 0,
                                              },
                                          }),
                                      ]
                                    : []),
                                ...(isMapEnabled
                                    ? [
                                          layout.nestedComposition({
                                              type: 'box',
                                              props: {
                                                  horizontalSpacing:
                                                      'outerMargin',
                                                  horizontalSpacingBreakpoint:
                                                      'lg',
                                              },
                                              contentAreas: {
                                                  main: [
                                                      layout.component({
                                                          type: 'election-map-overview-widget',
                                                          props: {
                                                              titleText:
                                                                  'Map overview',
                                                              electionDefinition,
                                                          },
                                                      }),
                                                  ],
                                              },
                                          }),
                                      ]
                                    : []),
                            ],
                        },
                    }),
                ],
            },
        }),
    ])
}
